// GeoLinkPage — /collections/geolink
//
// GeoLink hub. A simple card grid linking to the three GeoLink surfaces:
//   - Driver App      → /collections/geolink/driver-map  (live driver map)
//   - Nearby Bookings → /collections/geolink/nearby
//   - Coverage Analysis → /collections/geolink/coverage
//
// Matches the IntegrationsLandingPage convention (PageHeader + Card + a
// grid of Link cards) so the GeoLink hub looks like the rest of the
// Collections module.

import { Link } from 'react-router-dom';
import { BarChart3, Map, Navigation } from 'lucide-react';
import { PageHeader } from '../../../components/ui/PageHeader/PageHeader';
import { Card } from '../../../components/ui/Card/Card';
import styles from './GeoLinkPage.module.css';

interface HubOption {
  to: string;
  icon: React.ReactNode;
  label: string;
  description: string;
}

const OPTIONS: HubOption[] = [
  {
    to: '/collections/geolink/driver-map',
    icon: <Map size={20} aria-hidden />,
    label: 'Driver App',
    description: 'Live map of driver locations, fed from the Dispatch app.',
  },
  {
    to: '/collections/geolink/nearby',
    icon: <Navigation size={20} aria-hidden />,
    label: 'Nearby Bookings',
    description: 'Find live work near a postcode across bookings and skip jobs.',
  },
  {
    to: '/collections/geolink/coverage',
    icon: <BarChart3 size={20} aria-hidden />,
    label: 'Coverage Analysis',
    description: "See where you're winning — and where you could grow.",
  },
];

export function GeoLinkPage(): JSX.Element {
  return (
    <div className={styles.page}>
      <PageHeader
        title="GeoLink"
        subtitle="Map driver locations, find nearby work and analyse coverage."
      />

      <Card title="GeoLink tools">
        <ul className={styles.grid}>
          {OPTIONS.map((opt) => (
            <li key={opt.to}>
              <Link to={opt.to} className={styles.card}>
                <span className={styles.icon}>{opt.icon}</span>
                <span className={styles.text}>
                  <span className={styles.label}>{opt.label}</span>
                  <span className={styles.description}>{opt.description}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
